import EditUserPage from './EditUser';
import { createEditUserHandle } from './handle';

export default {
  Component: EditUserPage,
  createHandle: createEditUserHandle
};
